import { InfoCircleOutlined } from "@ant-design/icons";
import { Translations, ViewModule } from "@org-avp/avp-avengers-ui-shared-utils";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";
import { ImprintView } from "./lazy-view";

const translations: Translations = { de, en };

export const imprintViewKey = "app/imprint";
export const imprintViewModule: ViewModule = {
  viewKey: imprintViewKey,
  viewEl: <ImprintView/>,
  displayNameI18nKey: "app:imprintView.imprint.label",
  menuIconEl: <InfoCircleOutlined/>,
  translations,
};
